import type { ReactElement } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import {
    EducationBarIconButton,
    useEducationBarState,
    EducationBarContainer,
} from "app/pages/sales-intelligence/sub-modules/education-bar";
import opportunityListsStorage from "app/pages/sales-intelligence/sub-modules/opportunities/services/storage/storage";

type Props = {
    children: (props: { educationBarButton: ReactElement | null }) => ReactElement;
};

const WithEducationBar = ({ children }: Props): ReactElement => {
    const { state } = useCurrentStateAndParams();

    const { isBarVisible, onClose, onOpen } = useEducationBarState(opportunityListsStorage);

    return (
        <>
            {isBarVisible ? (
                <EducationBarContainer
                    stateId={state.stateId ?? ""}
                    onClose={onClose}
                />
            ) : null}

            {children({ educationBarButton: isBarVisible ? null : <EducationBarIconButton onClick={onOpen} /> })}
        </>
    );
};

export default WithEducationBar;
